"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var Block = function (_a) {
    var blockData = _a.blockData, children = _a.children;
    var background_data = blockData.background_image &&
        (0, react_1.useBreakpointValue)({
            base: blockData.background_image.sp,
            md: blockData.background_image.pc,
        });
    return (react_2.default.createElement(react_1.Box, { className: "" + (blockData.class || ""), css: blockData.style, backgroundImage: background_data || undefined },
        react_2.default.createElement(react_1.Box, { className: "container-fluid" }, children)));
};
exports.Block = Block;
